import { FormattedMessage } from 'react-intl';
import StarFilled from '@alltrails/denali/icons/StarFilled';
import styles from './AllFiltersModal.module.scss';

export const formatRatingValue = (rating: number, { showStarForAny = false }: { showStarForAny?: boolean } = {}) => {
  if (rating === 0) {
    if (!showStarForAny) {
      return <FormattedMessage defaultMessage="Any" />;
    }
    return (
      <div className={styles.ratingValue}>
        <StarFilled color="--color-text-primary" size="xs" />
        <span>
          <FormattedMessage defaultMessage="Any" />
        </span>
      </div>
    );
  }

  return (
    <div className={styles.ratingValue}>
      <StarFilled color="--color-text-primary" size="xs" />
      <span>
        {rating}
        {rating === 5 ? null : '+'}
      </span>
    </div>
  );
};
